import { useEffect, useState } from "react";
import { Alert, Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks";
import { getMerchantListAsync, MerchantState } from "../MerchantSlice";
import { FaEdit, FaTrash } from "react-icons/fa";
import { MerchantDetailInterface } from "../models/MerchantDetailInterface";
import ModuleConfig from "./../config/ModuleConfig";
import CustomPagination from "../../../utils/CustomPagination";
import { deleteMerchant } from "../MerchantAPI";
import { getPropByString } from "../../../utils/CommonFunction";
import Config from "../../../utils/config";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import AxiosInstance from "../../../utils/AxiosInstance"
import BackBtn from "../../common/BackBtn";
/**
 * Merchanting list page
 */
const MerchantList = () => {
  const { merchants, status, totalRecord } = useAppSelector(MerchantState);
  const [page, setPage] = useState(1);
  const dispatch = useAppDispatch();
  const [data, setData] = useState<any>([])
  const [search, setSearch] = useState("")
  const [statusTerm, setStatusTerm] = useState<any>("")
  const [order, setOrder] = useState("ASC")
  const [deleteItem, setDeleteItem] = useState("");

  useEffect(() => {
    getPageData();
  }, [dispatch, page,search, statusTerm]);

  useEffect(() => {
    if(merchants){
      setData(merchants)
    }
  },[merchants])

  const getPageData = () => {
    const filter = {
      page: page,
      search: search,
      status: statusTerm,
    };
    dispatch(getMerchantListAsync(filter));
  };

  const removeMerchant = async () => {
    const res = await deleteMerchant(deleteItem);
    if(res.data.status == 200){
      toast.success("Merchant deleted!" , {
        position: toast.POSITION.TOP_RIGHT
      });
    }
    setDeleteItem("");
    getPageData();
  };

  const sorting = (col: string) => {
    if (order === "ASC") {
      const sorted = [...data].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      )
      setData(sorted)
      setOrder("DESC")
    }
    if (order === "DESC") {
      const sorted = [...data].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      )
      setData(sorted)
      setOrder("ASC")
    }
  }

  const handleClear = () => {
    setSearch("");
    setStatusTerm("");
  }

  const loginAsMerchant =  async (e: any) => {
      const res = await AxiosInstance.post(`merchant/directlogin?id=${e}`);
      window.open(Config.loginAsUrl + res?.data?.data?.token);
    }

 
  return (
    <>
      <div className="page-header">
      <ToastContainer />
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-11">
              <div className="page-header-title">
                <h5 className="m-b-10">Merchant</h5>
              </div>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="feather icon-home"></i>
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <a>Merchants</a>
                </li>
              </ul>
            </div>
            <BackBtn />
          </div>
        </div>
      </div>

      <div className="main-body">
        <div className="page-wrapper">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <Row>
                    <Col auto>
                      <h5>Merchants</h5>
                    </Col>
                    <Col md={2}>
                      <Link className="btn btn-primary" to="/merchant/create">
                        Add Merchant
                      </Link>
                    </Col>
                  </Row>
                </div>
                <div className="row">
                  <div className="d-flex">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control col-12 ml-20"
                      style={{ marginTop: 50, marginBottom: 20, width: "40%" }}
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value)
                      }}
                    />
                    {/* </div>
                    <div className="col-4"> */}
                    <select
                      placeholder="Select Status"
                      className="form-control form-select col-12 ml-20"
                      value={statusTerm}
                      style={{ marginTop: 50, marginBottom: 20, width: "40%" }}
                      onChange={(e) => {
                        setStatusTerm(e.target.value)
                      }}
                    >
                      <option value="">Select Status</option>
                      <option value="Pending" >Pending</option>
                      <option value="Active" >Active</option>
                      <option value="Inactive">Inactive</option> 
                    </select>
                    <button
                      type="button"
                      className="btn btn-warning ml-20"
                      style={{ marginTop: 50, marginBottom: 20, width: "10%" }}
                      onClick={() => {
                        handleClear()
                        
                      }}
                    >Reset</button>
                  </div>
                </div>
                <div className="card-block table-border-style">
                  {status === "loading" ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : status === "failed" ? (
                    <Alert key={"danger"} variant={"danger"}>
                      Something went wrong please try again
                    </Alert>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              {ModuleConfig.listColumnOrder.map(
                                (column: string, index: number) => {
                                  return (
                                    <th key={`head_${index}`}  onClick={() => {
                                      sorting(column)
                                    }}>
                                      {ModuleConfig.listColumnLabel[column]}
                                    </th>
                                  );
                                }
                              )}
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.length >= 1 ? (
                              data?.filter((val: { merchant_detail: { business_name: string }; name: string; status: any }) => {
                                if (search === "" && statusTerm === "") {
                                  return val
                                } else if (
                                  val?.merchant_detail.business_name
                                    ?.toLocaleLowerCase()
                                    .includes(search.toLocaleLowerCase()) &&
                                    statusTerm === ""
                                ) {
                                  return val
                                } else if (
                                  val?.name
                                    ?.toLocaleLowerCase()
                                    .includes(search.toLocaleLowerCase()) &&
                                  val?.status == statusTerm
                                  // .includes(search.toLocaleLowerCase())
                                ) {
                                  return val
                                }
                              })
                              .map(
                                (
                                  merchant: MerchantDetailInterface,
                                  index: number
                                ) => {
                                  return (
                                    <tr key={`table_row_${index}`}>
                                      <>
                                        {ModuleConfig?.listColumnOrder?.map(
                                          (
                                            column: string,
                                            colIndex: number
                                          ) => {
                                            return (
                                              <td
                                                key={`table_row_${index}_${colIndex}`}
                                              >
                                                {colIndex == 5 ? (
                                                  <span
                                                    className={
                                                      "label " +
                                                      (getPropByString(
                                                        merchant,
                                                        column
                                                      ) == "Active"
                                                        ? "label-success"
                                                        : "label-danger")
                                                    }
                                                  >
                                                    {getPropByString(
                                                      merchant,
                                                      column
                                                    )}
                                                  </span>
                                                ) : (
                                                  getPropByString(
                                                    merchant,
                                                    column
                                                  )
                                                )}
                                              </td>
                                            );
                                          }
                                        )}

                                        <td>
                                          <Link
                                            className="btn btn-icon btn-success"
                                            to={`/merchant/update/${
                                              merchant[ModuleConfig.primaryKey]
                                            }`}
                                            title="Edit"
                                          >
                                            <i className="feather icon-edit"></i>
                                          </Link>

                                          <a
                                            className="btn btn-icon btn-danger"
                                            onClick={() =>
                                              setDeleteItem(merchant?.id || "")
                                            }
                                            title="Delete"
                                          >
                                            <i className="feather icon-trash-2"></i>
                                          </a>
                                          {merchant?.status == "Inactive" ? <></> :
                                          <a
                                            className="btn btn-icon btn-danger"
                                            onClick={() =>
                                              loginAsMerchant(merchant?.id)
                                            }
                                            title="Login as Merchant"
                                          >
                                            <i className="feather icon-user"></i>
                                          </a> }
                                        </td>
                                      </>
                                    </tr>
                                  );
                                }
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={
                                    ModuleConfig?.listColumnOrder?.length + 1
                                  }
                                >
                                  No Record.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <CustomPagination
                        curretnPage={page}
                        total={totalRecord}
                        limit={10}
                        setPage={setPage}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {deleteItem ? (
        <Modal show={true} onHide={() => setDeleteItem("")}>
          <Modal.Header closeButton>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete Merchant?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDeleteItem("")}>
              Close
            </Button>
            <Button className="btn-danger" variant="primary" onClick={removeMerchant}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  );
};
export default MerchantList;
